const ExperienceData = [
  {
    title: "Intern - AI-Powered Fraud Management System for UID Aadhaar",
    company: "Infosys Springboard",
    duration: "Feb. 2025 - Mar. 2025",
    description: [
      "Developed an AI-based fraud detection system for UID Aadhaar document verification using OCR pipelines, classification models, and YOLO-based object detection.",
      "Implemented advanced image preprocessing techniques to enhance model accuracy on low-quality and noisy inputs.",
      "Implemented fraud scoring and generated structured Excel/JSON reports to streamline verification workflows and reduce manual errors.",
      "Utilized a technical stack including Python, TensorFlow/PyTorch, YOLO, OpenCV, Tesseract OCR, Pandas, NumPy, and Flask.",
    ],
  },
];

export default ExperienceData;